import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { Dropdown } from 'components/v2/Dropdown'
import { DotsIcon } from 'components/Icons'
import List from 'components/v2/List'
import { StyledLink } from 'components/v2/Link'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite } from 'features/Users/utils'
import { GTCompanyRole } from 'gql/types.generated'
import { useLogin } from 'features/Login/hooks'
import IconButton from 'components/v2/IconButton'

export const CompanyRolesList = ({ companyRoles = [] }: { companyRoles: GTCompanyRole[] }): ReactElement => {
  const login = useLogin()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.POLICY, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="dictionary.name" defaultMessage="Name" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.permissions" defaultMessage="Permissions" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {companyRoles.map((companyRole): ReactElement => {
            return (
              <Tr key={companyRole.id}>
                {canWrite(FEATURES.POLICY, login.accessToken.policies) && (
                  <Td>
                    <Dropdown
                      toggle={<IconButton icon={<DotsIcon />} noBorder smallPadding />}
                      noPadding
                      noIndicator
                      left
                    >
                      <List.Container>
                        <List.Item noPadding>
                          <List.Link to={`/company-roles/${companyRole.id}`}>
                            <FormattedMessage id="companyRoles.list.actions.edit" defaultMessage="Edit company role" />
                          </List.Link>
                        </List.Item>
                      </List.Container>
                    </Dropdown>
                  </Td>
                )}
                <Td>{companyRole.name}</Td>
                <Td>
                  {companyRole.permissions.length > 0 ? (
                    <Dropdown toggle={<StyledLink>{companyRole.permissions.length}</StyledLink>} noPadding>
                      <List.Container>
                        {companyRole.permissions.map((permission: TSFixMe): TSFixMe => {
                          return <List.Item key={permission.id}>{permission.name}</List.Item>
                        })}
                      </List.Container>
                    </Dropdown>
                  ) : (
                    0
                  )}
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
